import '../../../styles/src/05-components/author-spotlight-testimonial/style.scss';

document.addEventListener(
    "DOMContentLoaded", () => {
        // If mobile, move member details
        function moveMemberName() {
            if (window.innerWidth < 991) {
                document.querySelector('.author-spotlight-testimonial__content').prepend(document.querySelector('.author-spotlight-testimonial__member'));
            }
        }
        moveMemberName();
        window.addEventListener('resize', function() {
            moveMemberName();
        });

        // All social links open new tab
        Array.from(document.querySelectorAll('.author-spotlight-testimonial__social-wrapper .social-network')).forEach(element => {
            element.setAttribute('target', '_blank');
        });
    }
);